import { render, staticRenderFns } from "./JobPagePraktikum.vue?vue&type=template&id=8e505c86&scoped=true&"
import script from "./JobPagePraktikum.vue?vue&type=script&lang=js&"
export * from "./JobPagePraktikum.vue?vue&type=script&lang=js&"
import style0 from "./JobPagePraktikum.vue?vue&type=style&index=0&id=8e505c86&prod&lang=scss&scoped=true&"
import style1 from "./JobPagePraktikum.vue?vue&type=style&index=1&id=8e505c86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e505c86",
  null
  
)

export default component.exports